import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// PAGES
import Home from './routes/Home';
import Layout from '../layouts';
import PageNotFound from './routes/PageNotFound';

const AppRouter = () => {
	return (
		<Router>
			<Routes>
				<Route path='/' element={<Layout />}>
					<Route path='/' element={<Home />} />

					<Route path='*' element={<PageNotFound />} />
				</Route>
			</Routes>
		</Router>
	);
};

export default AppRouter;
